// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"790":"9535533f","934":"4a63a5d0"}[chunkId] + ".chunk.js";
};